var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.22322 18.3333C5.22322 17.873 5.59632 17.4999 6.05655 17.4999H14.3899C14.8501 17.4999 15.2232 17.873 15.2232 18.3333C15.2232 18.7935 14.8501 19.1666 14.3899 19.1666H6.05655C5.59632 19.1666 5.22322 18.7935 5.22322 18.3333Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2232 10.8333C10.6835 10.8333 11.0566 11.2063 11.0566 11.6666V18.3333C11.0566 18.7935 10.6835 19.1666 10.2232 19.1666C9.76298 19.1666 9.38989 18.7935 9.38989 18.3333V11.6666C9.38989 11.2063 9.76298 10.8333 10.2232 10.8333Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21594 1.17644C6.37276 0.96082 6.62327 0.833252 6.88989 0.833252H13.5566C13.8232 0.833252 14.0737 0.960817 14.2305 1.17643C15.6982 3.19449 16.7235 6.35182 15.5696 8.98034C14.673 11.023 12.6237 12.4999 10.2232 12.4999C7.91699 12.4999 5.92498 11.1615 4.97853 9.22285C3.67172 6.54565 4.70119 3.25921 6.21594 1.17644ZM6.47624 8.49166C5.60877 6.71445 6.15422 4.3047 7.32778 2.49992L6.47624 8.49166ZM7.32778 2.49992H13.1187C14.2531 4.24399 14.8105 6.5632 14.0435 8.31041C13.3963 9.78488 11.9222 10.8333 10.2232 10.8333C8.57805 10.8333 7.15397 9.87982 6.47624 8.49166"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlco);
export default __webpack_public_path__ + "static/media/alco.ee6d110f013f61d540b726c6757fa60c.svg";
export { ForwardRef as ReactComponent };